import * as React from "react";
import ObAssetsDetl from "../../instruments/details/obAssetsDetl";
import EdButton from "../../../../generic/edButton";
import ObMfDtlContent from "./obMfDtlContent";
import "../../../../../assets/scss/components/toc/orderBook/obModifyState/obModify.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetails.scss";
import "../../../../../assets/scss/components/toc/orderBook/obDetails/obAssetDetailstab.scss";
import moment from "moment";
import { ObAssetsDetlProps } from "../../instruments/details/obAssetsDetl";
import { ChipStatusComb } from "../../obConstants";

export interface IObMfDtlDskProps {
	data: any;
	onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void; // the function to be called onClick
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ObMfDtlDsk: React.FC<IObMfDtlDskProps> = (props) => {
	const backButtonValue = (
		<>
			<i className="arrow_left edel-icon-arrow-left vTextTop" />
			<span>Back</span>
		</>
	);

	const assetDetail: ObAssetsDetlProps = {
		date: props.data.txnDate ? moment(new Date(props.data.txnDate)).format("D MMM YYYY, HH:mm:ss") : "",
		trsTyp: props.data.txnType !== "R" ? "BUY" : "SELL",
		title: props.data.schemeName,
		sts: ChipStatusComb[props.data.status.toLowerCase()]
	};

	return (
		<section className="ob_detail_container">
			<section className="ob_detail_wrapper">
				<section className="list_view">
					<div className="ly_list_view ">
						{/* left menu back button */}
						<div className="lv_menu bckBtnDiv ">
							<EdButton value={backButtonValue} btnTyp="link" onClick={props.onBackClick} className="icon_button" />
						</div>
					</div>
					<div className="ob_right_cont ly_right_cont">
						<div className="ob_detail_view">
							{/* header section */}
							<div className="dv_content">
								<div className="ob_header">
									<ObAssetsDetl {...assetDetail} />
									{/* when status is rejected will show below content */}
									{props.data.remarks && props.data.status.toLowerCase() === "rejected" && (
										<div className="rjct_reason">
											<p className="rsn_hd">Reason</p>
											<p className="rsn">{props.data.remarks}</p>
										</div>
									)}
								</div>
								{/* detailed content */}
								<div>
									<hr className="slim_line" />
									<ObMfDtlContent data={props.data} onCancelClick={props.onCancelClick} />
								</div>
							</div>
						</div>
					</div>
				</section>
			</section>
		</section>
	);
};

export default ObMfDtlDsk;
